export default __webpack_public_path__ + "static/Century_Gothic_Rg-5048323187558514cd35fe5bf0518d77.woff2";